import { CloseIcon } from '@chakra-ui/icons';
import {
  Button,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import React from 'react';

const ChangeGroupName = ({
  onClose,
  isModal,
  setGroupName,
  groupName,
  handleUpdateGroupName,
}) => {
  const { t } = useTranslator();
  const warningText =
    isModal?.data === 'create'
      ? t('myMessages.createGroupNameDescription') || 'Create the name of a group.'
      : t('myMessages.changingGroupNameForAll') || `Changing the name of a group changes it for everyone.`;
  return (
    <>
      <Modal isOpen={isModal?.open} closeOnOverlayClick={true} isCentered>
        <ModalOverlay />
        <ModalContent
          backgroundColor="#FFFFFF"
          padding="5px 5px 0px 5px"
          maxWidth="436px"
          borderRadius="16px"
        >
          <ModalHeader>
            <HStack alignItems="center" justifyContent="space-between">
              <Heading
                fontSize="15px"
                fontFamily="Inter"
                lineHeight="18px"
                fontWeight={600}
                color="#5B5B5B"
              >
                {isModal?.data !== 'create'
                  ? t('myMessages.changeGroupName') || 'Change group name'
                  : t('myMessages.createGroupName') || 'Create group name'}
              </Heading>
              <CloseIcon
                width="10px"
                height="10px"
                color="#5B5B5B"
                fontWeight={600}
                onClick={() => onClose()}
              />
            </HStack>
          </ModalHeader>
          <ModalBody>
            <VStack gap="16px">
              <Text maxWidth="388px" w="100%">
                {warningText}
              </Text>
              <Input
                placeholder={t('myMessages.groupname') || "Group name"}
                fontFamily="Inter"
                fontWeight={400}
                fontSize="16px"
                lineHeight="19.2px"
                color="#5B5B5B"
                borderRadius="8px"
                border="1px solid #E4E6EB"
                background="transparent"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
            </VStack>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button
                backgroundColor="transparent"
                border="1px solid #D9D9D9"
                borderRadius="76px"
                p="9px 18px"
                fontSize="12px"
                fontWeight={500}
                lineHeight="14.4px"
                color="#3D5A80"
                _hover={{
                  backgroundColor: 'transparent',
                }}
                onClick={() => onClose()}
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                backgroundColor="#3D5A80"
                border="1px solid #D9D9D9"
                borderRadius="76px"
                p="9px 18px"
                fontSize="12px"
                fontWeight={500}
                lineHeight="14.4px"
                color="#FFFFFF"
                _hover={{
                  backgroundColor: '#3D5A80',
                }}
                onClick={() => handleUpdateGroupName()}
              >
                {t('buttons.save') || "Save"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ChangeGroupName;
